import { render, staticRenderFns } from "./InfoDlg.vue?vue&type=template&id=3bf8658e&scoped=true"
import script from "./InfoDlg.vue?vue&type=script&lang=ts"
export * from "./InfoDlg.vue?vue&type=script&lang=ts"
import style0 from "./InfoDlg.vue?vue&type=style&index=0&id=3bf8658e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf8658e",
  null
  
)

export default component.exports